import {
  FETCH_EXAM_RESULT_SUCCESS,
  FETCH_EXAM_RESULT_FAILURE,
  SAVE_EXAM_RESULT_SUCCESS,
  SAVE_EXAM_RESULT_FAILURE,
  DELETE_EXAM_RESULT_SUCCESS,
  DELETE_EXAM_RESULT_FAILURE,
  CLEAR_EXAM_RESULT,
} from "./actionTypes"

const initialState = {
  result: null,
  loading: false,
  error: null,
}

export default function examResultReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_EXAM_RESULT_SUCCESS:
      return {
        ...state,
        result: action.payload.result,
        loading: false,
        error: null,
      }
    case FETCH_EXAM_RESULT_FAILURE:
      return { ...state, loading: false, error: action.payload.error }
    case SAVE_EXAM_RESULT_SUCCESS:
      return {
        ...state,
        result: action.payload.result,
        loading: false,
        error: null,
      }
    case SAVE_EXAM_RESULT_FAILURE:
      return { ...state, loading: false, error: action.payload.error }
    case DELETE_EXAM_RESULT_SUCCESS:
      return { ...state, result: null, loading: false, error: null }
    case DELETE_EXAM_RESULT_FAILURE:
      return { ...state, loading: false, error: action.payload.error }
    case CLEAR_EXAM_RESULT:
      return { ...state, result: null, error: null }
    default:
      return state
  }
}
